import { ReactNode } from "react";

import { Anchor, Card, Group, Stack, Text } from "@mantine/core";
import { HlstudioSmall } from "~/../../base-components/lib/assets/icons.generated";
import { ArrowUpRight } from "~/../../base-components/lib/assets/icons.generated/HDS/Duotone icons/Arrows";
import { BACKGROUND_COLOR } from "~/../../base-components/lib/theme/colors";

const HLStudioLink = (props: {
  link: string;
  title?: ReactNode;
  text?: ReactNode;
}) => {
  const { link, title, text } = props;

  return (
    <Anchor underline={false} href={link} target="_blank" rel="noreferrer">
      <Card bg={BACKGROUND_COLOR.SECONDARY} p={"md"}>
        <Group noWrap spacing={"md"}>
          <HlstudioSmall width={32} height={32} style={{ flexShrink: 0 }} />
          <Stack spacing={0} style={{ flexGrow: 1 }}>
            {title && (
              <Text size="sm" fw={500}>
                {title}
              </Text>
            )}
            {text && <Text size="sm">{text}</Text>}
          </Stack>
          <ArrowUpRight height={20} width={20} style={{ flexShrink: 0 }} />
        </Group>
      </Card>
    </Anchor>
  );
};

export default HLStudioLink;
